import { LoaderCircle } from "lucide-react";

export const version = "Version 1.1.1";
export const versionShort = "V1.1.1";

export const requiredBadge = () => {
  return <span className="text-red-500">*</span>;
};

export function LoaderProgress(size: number = 30, stroke: number = 2) {
  return (
    <LoaderCircle
      className="spinner text-pageBg"
      size={size}
      strokeWidth={stroke}
    />
  );
}

export function handleOnWheel(e: any) {
  if (e) {
    return e.target.blur();
  }
}

export function handleKeyPress(e: any, restriction: string) {
  if (e) {
    if (restriction === "-") {
      if (e.key === "-") {
        e.preventDefault();
      }
    } else if (restriction === "arrow") {
      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
      }
    } else {
      if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "-") {
        e.preventDefault();
      }
    }
  }
}

export function handleChangePage(
  current: any,
  setFilterConfig: React.Dispatch<React.SetStateAction<any>>
) {
  setFilterConfig((prev: any) => ({
    ...prev,
    page: current,
  }));
}

export const handlePageSizeChange = (size: number, setFilterConfig: any) => {
  setFilterConfig((prev: any) => ({ ...prev, page: 1, page_size: size }));
};
